import { AxiosResponse } from 'axios';
import api from '../api';
import { Share_Type } from '../constants/common.constant';
import { SORT_ORDER } from '../constants/filter.constant';
import { DefaultResponse } from '../interfaces/index';

const SHARE_URL = '/studyshares/v1';

/* export interface ResponseShareAccessKey extends DefaultResponse {
  data: {
    access_type: Share_Access;
    body_parts: string[];
    expired_at: Date;
    id: string;
    institution_id: string;
    is_expired: boolean;
    is_require_password: boolean;
    modalities: string[];
    note: string;
    patient_id: string;
    patient_name: string;
    share_study_id: string;
    share_study_instance_uid: string;
    type: Share_Type | unknown;
  };
}
export const getShareAccessKey = async (id: string) => {
  const response = (await api({
    url: `studyshares/public/v1/${id}`,
    method: 'GET',
  })) as AxiosResponse<ResponseShareAccessKey>;

  return response.data;
}; */

export enum ACCESS_TYPE {
  Study,
  'Visit ID',
}

export interface ParamsShare {
  access_type: ACCESS_TYPE;
  body_part?: string;
  created_at_from?: string;
  created_at_to?: string;
  creator_ids?: string[];
  institution_ids?: string[];
  limit?: number;
  modalities?: string[];
  offset?: number;
  patient_id?: string;
  patient_name?: string;
  share_study_id?: string;
  sort_field?:
    | ''
    | 'type'
    | 'patient_id'
    | 'patient_name'
    | 'institution_id'
    | 'created_at';
  sort_order?: SORT_ORDER;
  study_instance_uid?: string;
  type: Share_Type;
  visit_id?: string;
}
export interface SharesResponse extends DefaultResponse {
  data: {
    data: {
      access_key: string;
      access_type: ACCESS_TYPE;
      body_parts: string[];
      created_at: string;
      creator_id: string;
      expired_at: string;
      id: string;
      institution_id: string;
      modalities: string[];
      note: string;
      password: string;
      patient_id: string;
      patient_name: string;
      share_study_id: string;
      share_study_instance_uid: string;
      type: number;
      updated_at: string;
      visit_id: string;
    }[];
    is_exceed_limit: boolean;
  };
}
export const getShares = async (params: ParamsShare) => {
  const response = (await api({
    url: SHARE_URL,
    method: 'GET',
    params,
    timeout: 30_000,
  })) as AxiosResponse<SharesResponse>;

  return response.data;
};

export const getShareByAccessKey = async (access_key: string) => {
  const response = (await api({
    url: `${SHARE_URL}/${access_key}`,
    method: 'GET',
    timeout: 30_000,
  })) as AxiosResponse<SharesResponse>;

  return response.data;
};

export interface ParamsCreateShare {
  access_type?: ACCESS_TYPE;
  body_parts?: string[];
  expired_at: string;
  institution_id?: string;
  modalities?: string[];
  note?: string;
  password?: string;
  patient_id?: string;
  patient_name?: string;
  share_study_id?: string;
  share_study_instance_uid?: string;
  type?: number;
  visit_id: string;
}
export const createShare = async (data: ParamsCreateShare) => {
  const response = (await api({
    url: SHARE_URL,
    method: 'POST',
    data,
  })) as AxiosResponse<any>;

  return response.data;
};

export interface ParamsUpdateShare {
  access_type?: ACCESS_TYPE;
  expired_at?: string;
  note?: string;
  password?: string;
  type?: Share_Type;
}
export const updateShare = async (id: string, data: ParamsUpdateShare) => {
  const response = (await api({
    url: `${SHARE_URL}/${id}`,
    method: 'PUT',
    data,
  })) as AxiosResponse<any>;

  return response.data;
};

export const deleteShare = async (id: string) => {
  return (await api({
    url: `${SHARE_URL}/${id}`,
    method: 'DELETE',
  })) as AxiosResponse<any>;
};

export const getDetailShare = async (params: ParamsShare) => {
  const response = (await api({
    url: SHARE_URL,
    method: 'GET',
    timeout: 30_000,
    params: { offset: 0, ...params },
  })) as AxiosResponse<SharesResponse>;

  return response.data;
};
